export default "__VITE_ASSET__DOl_2Dva__"